// extracted by mini-css-extract-plugin
export var column = "FooterMain-module--column--87215";
export var copyright = "FooterMain-module--copyright--f74cd";
export var menuItem = "FooterMain-module--menuItem--e0627";
export var paragraph = "FooterMain-module--paragraph--49aee";
export var root = "FooterMain-module--root--71f2c";
export var title = "FooterMain-module--title--5e8d0";